export class Location {
    public id: number;
    public description: string;
    public type: string;
    public active: boolean;
    public version: number;
    public validFrom: string;
    public validTo: string;
}